// extracted by mini-css-extract-plugin
export default {"loaderContainer":"CommonLoader_loaderContainer__GY1Eh"};